import React, { Fragment } from 'react';
import FetchImage from '../../FetchData/FetchImage';

import { onSelectRoom } from '../../../appRedux/actions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

const NewChatItem = ({ item, setShowMenu }) => {
  const { Name, EmployeeIdReceiver } = item;
  const dispatch = useDispatch();
  let history = useHistory();

  return (
    <li
      className="gx-media gx-d-flex gx-align-items-center"
      onClick={() => {
        dispatch(onSelectRoom(item));
        let baseUrl = '/team-work/chat?';
        setShowMenu(false);

        if (item.Id) baseUrl += `roomId=${item.Id}`;

        history.push(baseUrl);
      }}
    >
      <div className="gx-user-thumb gx-ml-1 gx-mr-1">
        {EmployeeIdReceiver ? (
          <Fragment>
            <FetchImage
              src={`contactPicture/getContactPicture?id=${EmployeeIdReceiver}&height=${40}&width=${40}`}
              className="ant-avatar-lg"
              alt="مخاطبین"
            />
          </Fragment>
        ) : (
          <img
            src={require('../../../assets/images/avatar/group.svg')}
            alt="chat-group"
            title="chat-group"
            className="ant-avatar-lg"
            style={{ border: '1px solid gray' }}
          />
        )}
      </div>
      <div className="gx-media-body gx-d-flex gx-justify-content-between gx-align-items-center">
        <div>
          <h5 className="gx-text-capitalize gx-user-name gx-mb-0">
            <span className="gx-link">{Name}</span>
          </h5>
        </div>
        <span className="gx-btn gx-btn-sm gx-top2 gx-text-muted gx-mb-0">
          <span>خواندن پیام‌ها</span>
          <i className="icon icon-custom-view gx-pr-2" />
        </span>
      </div>
    </li>
  );
};

export default NewChatItem;
